import { PatientBillInfoDto } from "../../../../api-client";
import { TarifGroupIds } from "../../../Transactions/Kasse/v2/types/kasse.types";

/**
 * Small helpers to derive SEPA charge fields from a bill row, matching the legacy
 * `usePatientBillingActions` conventions (text + bookkeeping account by tarif group).
 */

export function billChargeText(bill: PatientBillInfoDto): string {
  return bill.tarifGroupId !== TarifGroupIds.PRIVATE ? "Zuzahlung" : "Privatzahlung";
}

export function billTAccountId(bill: PatientBillInfoDto): number {
  return bill.tarifGroupId !== TarifGroupIds.PRIVATE ? 4101 : 4105;
}

/** Payment is blocked while the price is only estimated (not all appointments planned). */
export function isPaymentBlocked(bill: PatientBillInfoDto): boolean {
  return bill.isEstimated && !bill.isTimeSlotZero;
}
